import { ComponentType } from 'react';

import { TaskGroupSummary } from 'modules/Tasks/types';
import MonthlyStatementUploadGroup from 'modules/Tasks/Groups/customComponents/MonthlyStatementUploadGroup';
import MonthlyReimbursementGroup from 'modules/Tasks/Groups/customComponents/MonthlyReimbursementGroup';
import BuildingBackBooksGroup from 'modules/Tasks/Groups/customComponents/BuildingBackBooksGroup';

type CustomGroupComponent = ComponentType<{
    open: boolean;
    onClose: () => void;
    group: TaskGroupSummary;
}>;

// Custom group flows register here as they ship (group_action.type === 'custom').
const groupComponentRegistry: Record<string, CustomGroupComponent> = {
    monthly_bank_statements: MonthlyStatementUploadGroup,
    monthly_reimbursement: MonthlyReimbursementGroup,
    building_back_books: BuildingBackBooksGroup,
};

export default groupComponentRegistry;
